import React from "react";
import {withGoogleMap, GoogleMap, Marker, Polyline} from "react-google-maps/lib";
import mapStyle from "./mapStyle";

const MapComponent = withGoogleMap((props, idx) => (
  <GoogleMap
    ref={props.onMapLoad}
    defaultZoom={12}
    defaultCenter={{lat: props.pickupLat, lng: props.pickupLong}}
    onClick={props.onMapClick}
    defaultOptions={{ styles: mapStyle }}>

    <Polyline
      geodesic = {true}
      strokeColor = {"#FD5B44"}
      strokeOpacity = {1.0}
      strokeWeight = {10}
      path={props.coords}
      options = {{strokeColor : "#FD5B44"}} />

    {props.markers.map((marker, key) => (
      <Marker
        {...marker}
        key = {key}
        icon = "../../public/images/icons_png/location_pin.png"
        onRightClick={() => props.onMarkerRightClick(marker)}
      />
    ))}
  </GoogleMap>
));

export default class Map extends React.Component {

  constructor(props){
    super(props);
    const deliveryLat  = props.deliveryLat,
          deliveryLong = props.deliveryLong,
          pickupLat = props.pickupLat,
          pickupLong = props.pickupLong;

    this.state = {
      markers: [
        {
          position: {
            lat: deliveryLat,
            lng: deliveryLong,
          },
          defaultAnimation: 2
        },
        {
          position: {
            lat: props.pickupLat,
            lng: props.pickupLong,
          },
          defaultAnimation: 2
        }
    ],
      deliveryLat: deliveryLat,
      deliveryLong: deliveryLong,
      pickupLat: pickupLat,
      pickupLong: pickupLong
    };

    this.handleMapLoad = this.handleMapLoad.bind(this);
    this.handleMarkerRightClick = this.handleMarkerRightClick.bind(this);
  }

  handleMapLoad(map) {
    this._mapComponent = map;
    if (map) {

    }
  }

  handleMarkerRightClick(targetMarker) {

  }

  render() {
    const {state,props} = this;
    let coords =  [{ lat: props.deliveryLat, lng: props.deliveryLong },
                  { lat: props.pickupLat, lng: props.pickupLong }];

    return (
      <div style={{height: `300px`}}>
        <MapComponent
          containerElement={<div style={{ height: `300px` }} />}
          mapElement={<div style={{ height: `300px` }} />}
          onMapLoad={this.handleMapLoad}
          onMapClick={this.handleMapClick}
          markers={state.markers}
          onMarkerRightClick={this.handleMarkerRightClick}
          deliveryLat = {state.deliveryLat}
          deliveryLong = {state.deliveryLong}
          pickupLat = {state.pickupLat}
          pickupLong = {state.pickupLong}
          coords = {coords}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// app/shipment/map.jsx